export const SIGN_UP = "signUp";
export const SIGN_UP_WITH_FACEBOOK = "signUpWithFacebook";
export const LOGIN = "login";
export const SAVE_TOKEN = "accessToken";
export const SET_USER_LOGGED = "setUserLogged";
export const LOGOUT = "logout";
export const FORGOT_PASSWORD = "forgotPassword";
export const CONFIRM_EMAIL = "confirmEmail";
export const RESEND_EMAIL = "resendEmail";
export const CHANGE_LOGGED_IN_STATUS = "changeLoginStatus";
export const CHANGE_USER_EDITED_VALUE = "changeEditedValue";
export const REMOVE_USER_DETAILS = "removeUserDetails";

/* FOR PUBLIC PAGES */
export const PUBLIC_PAGES = "publicPages";